import { render, staticRenderFns } from "./RealTimeChatMain.vue?vue&type=template&id=5a0ea726"
import script from "./RealTimeChatMain.vue?vue&type=script&lang=js"
export * from "./RealTimeChatMain.vue?vue&type=script&lang=js"
import style0 from "./RealTimeChatMain.vue?vue&type=style&index=0&id=5a0ea726&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports